//const backend_url = process.env.REACT_APP_ENVIROMENT === 'production' ? process.env.REACT_APP_BACKEND_PRODUCTION_URL : process.env.REACT_APP_BACKEND_DEVELOPMENT_URL;
const backend_url = process.env.REACT_APP_BACKEND_PRODUCTION_URL;
export const endpoints = {
    login: `${backend_url}/admin/api/admin-login`,
    register: `${backend_url}/user/sign-up`,
    socialLogin: `${backend_url}/auth/social-login`,
    sendOtp: `${backend_url}/api/forgot-password`,
    sendNotification: `${backend_url}/admin/api/notifications/send`,
    updateNotification: `${backend_url}/user/allow/notification`,
    verifyOtp: `${backend_url}/api/admin-verify-otp`,
    resetPassword: `${backend_url}/admin/api/admin-update-password`,
    changePassword: `${backend_url}/api/change-password`,
    logout: `${backend_url}/admin/api/logout`,
    profile: `${backend_url}/api/user-profile`,
    getUserDetail: `${backend_url}/admin/api/user-profiles`,
    getQuizDetail: `${backend_url}/admin/api/quiz`,
    getSubscriptionDetail: `${backend_url}/admin/api/edit-plan`,
    dashboard: `${backend_url}/admin/api/dashboard`,
    updateProfile: `${backend_url}/user/profile`,
    deleteAccount: `${backend_url}/user/delete`,
    getTrips: `${backend_url}/trip`,
    dashboardData: `${backend_url}/dashboard/today-trips-expenses`,
    addTrip: `${backend_url}/trip`,
    updateTrip: `${backend_url}/trip`,
    deleteTrip: `${backend_url}/trip`,
    addUser: `${backend_url}/admin/api/create-user`,
    addQuiz: `${backend_url}/admin/api/quiz`,
    previewQuizExcel: `${backend_url}/admin/api/quiz/excel-preview`,
    uploadQuizExcel: `${backend_url}/admin/api/quiz/excel-upload`,
    uploadImage: `${backend_url}/admin/api/image-upload`,
    updateUser: `${backend_url}/admin/api/update-user`,
    updateQuiz: `${backend_url}/admin/api/quiz`,
    updateSubscription: `${backend_url}/admin/api/update-plan`,
    deleteQuiz: `${backend_url}/admin/api/quiz`,
    deleteSupport: `${backend_url}/admin/api/support`,
    deleteUser: `${backend_url}/api/user`,
    getTc: `${backend_url}/admin/api/terms`,
    updateTc: `${backend_url}/admin/api/terms`,
    getLocations: `${backend_url}/locations`,
    addLocation: `${backend_url}/locations`,
    editLocation: `${backend_url}/locations`,
    deleteLocation: `${backend_url}/locations`,
    addReading: `${backend_url}/odometer`,
    updateReading: `${backend_url}/odometer`,
    deleteReading: `${backend_url}/odometer`,
    getReading: `${backend_url}/odometer`,
    addRate: `${backend_url}/mileage-rate`,
    customRates: `${backend_url}/mileage-rate`,
    updateRate: `${backend_url}/mileage-rate`,
    // getReports: `${backend_url}/reports/list`,
    getReports: `${backend_url}/reports/v2/list`,
    // addReport: `${backend_url}/reports`,
    addReport: `${backend_url}/reports/v2`,
    xlsReport: `${backend_url}/reports/generate/xls`,
    pdfReport: `${backend_url}/reports/v2/generatePdfReportNew`,
    // pdfReport: `${backend_url}/reports/generate`,
    updateReport: `${backend_url}/reports`,
    reportMail: `${backend_url}/reports/send`,
    // deleteReport: `${backend_url}/reports`,
    // reportDetail: `${backend_url}/reports`,
    reportDetail: `${backend_url}/reports/v2/getReportDetails`,
    tripsToReport: `${backend_url}/reports/v2/addTripsToReport`,
    expensesToReport: `${backend_url}/reports/v2/addExpensesToReport`,
    submitReport: `${backend_url}/reports/v2/submitReport`,
    createTeam: `${backend_url}/teams/create`,
    teamsList: `${backend_url}/teams/list`,
    teamsTree: `${backend_url}/teams/team-tree`,
    parentTeams: `${backend_url}/teams/team-dropdown`,
    inviteMembers: `${backend_url}/members/invite`,
    membersList: `${backend_url}/members/list`,
    updateInfo: `${backend_url}/members`,
    memberTrips: `${backend_url}/teams/all-trips`,
    UserList: `${backend_url}/admin/api/user-list`,
    SupportList: `${backend_url}/admin/api/support`,
    updateSupportStatus: `${backend_url}/admin/api/supports`,
    getSupport: `${backend_url}/admin/api/support`,
    QuizList: `${backend_url}/admin/api/quiz-by-category`,
    SubscriptionList: `${backend_url}/admin/api/plans`,
    CategoryList: `${backend_url}/admin/api/quiz-category`,
    teamMembers: `${backend_url}/teams/members-list-details`,
    memberExpenses: `${backend_url}/teams/trips-expense`,
    memberReports: `${backend_url}/teams/trips/report`,
    memberInfo: `${backend_url}/members/info`,
    teamCategories: `${backend_url}/teams/team-category`,
    addCategory: `${backend_url}/admin/api/quiz-category`,
    editCategory: `${backend_url}/admin/api/update`,
    addPlaces: `${backend_url}/teams/add-team-paces`,
    placesList: `${backend_url}/teams/team-places`,
    rolesList: `${backend_url}/teams/team-roles`,
    updateTeamName: `${backend_url}/teams/update-team-name`,
    getSummary: `${backend_url}/teams/team-summary`,
    onboardingMembers: `${backend_url}/members/getOnboardingMembers`,
    categoriesUploadMultiple: `${backend_url}/teams/upload-category`,
    placesUploadMultiple: `${backend_url}/teams/upload-places`,
    managersList: `${backend_url}/teams/manager-list-details`,
    removeManager: `${backend_url}/teams/remove-manager`,
    content: `${backend_url}/user/content`,
    exports: `${backend_url}/teams/export-files`,
    summaryReport: `${backend_url}/teams/generate-export`,
    memberReport: `${backend_url}/teams/generate-member-export`,
    // subscriptionPlans: `${backend_url}/subscription/offerings`,
    subscriptionPlans: `${backend_url}/subscription/get-subs`,
    upgradePlan: `${backend_url}/subscription/checkout`,
    membersDropdown: `${backend_url}/members/dropdown`,
    subscriptionSuccess: `${backend_url}/subscription`,
    reimbursementList: `${backend_url}/reports/v2/reimbursementList`,
    checkInvitation: `${backend_url}/members/check-invitation`,
    acceptInvitation: `${backend_url}/members/accept-invitation`,
    reimbursementSubmit: `${backend_url}/reports/v2/acceptRejectReport`,
    renameReport: `${backend_url}/reports/v2/renameReport`,
    deleteReport: `${backend_url}/reports/v2/delete`,
    firstLogin: `${backend_url}/auth/first-login`,
    reimbursementGraphData: `${backend_url}/reports/v2/reimbursementHistoryByMonth`,
    uploadBanner: `${backend_url}/admin/api/upload-banner`,
    getCategories: `${backend_url}/admin/api/categories`,
    addNewCategory: `${backend_url}/admin/api/quiz-category`,
    NotificationLogs: `${backend_url}/admin/api/notifications-logs`,
    verifyAdminLoginOtp: `${backend_url}/admin/api/verify-login-otp2FA`,
    resendAdminLoginOtp: `${backend_url}/admin/api/resend-login-otp2FA`,
    quizFirstAttemptStats: `${backend_url}/admin/api/quiz-first-attempt-stats`,
}

export default backend_url;


